module.exports = __webpack_public_path__ + "img/dsci0013.374fae99.jpg";